//引入接口文档
import req from '@/utils/req.js' 

//渠道类型下拉数据
export function getChannelType(params) {
  return req.get("/admin/category/channel_type/children",params);
}
// 卡密列表 
export function cardPage(params) {
  return req.get("/biz/dsicm-card/page",params);
}
//卡密使用记录 
export function cardRecord(params) {
  return req.get("/biz/dsicm-card-record/page",params);
}

//卡密导出
export function cardExport(params) {
  return req.getUpload("/biz/dsicm-card-record/export",params);
}
// 更新启停状态 
export function updateStatus(params) {
  return req.put("/biz/dsicm-card/state", params,{loading:true});
} 

//卡密详情
export function cardDetails(cardId) {
  return req.get(`/biz/dsicm-card/${cardId}`);
}
// 添加卡密 
export function addCard(params) {
  return req.post(`/biz/dsicm-card`,params,{loading:true});
}
// 编辑卡密 
export function editeCard(params) {
  return req.put(`/biz/dsicm-card`,params,{loading:true});
}